import { User } from 'mvppoker-portal-common/api'
import React from 'react'
import { MVPButton } from '../../Buttons/MVPButton'
import './PaymentModal.scss'

export interface PaymentModalViewProps
{
	user: User
	success: boolean
	clickConfirm: () => void
}
export const PaymentModalView : React.FC<PaymentModalViewProps> = ({ user, success, clickConfirm }) =>
{
	return (
		<>
			<span className='modal-title-l'>Payment Processing</span>
			{success && <span className='modal-subtitle'>Your payment was successful!<br/><br/>Please allow a moment for it to be credited into your MVP Wallet.</span>}
			{!success && <span className='modal-subtitle'>Your payment had some problem.<br/><br/>Please try again!</span>}
			<div className='buttons'>
				<MVPButton className='light' onClick={clickConfirm}>
					OK
				</MVPButton>
			</div>
		</>
	)
}